const FacebookIcon = ({ invert }) =>
  <svg width='36' height='36' viewBox='0 0 36 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <title>Facebook Icon</title>
    <circle cx='18' cy='18' r='15' fill={invert ? 'white' : '#171717'} />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M21.9863 12.7184C21.5188 12.6249 20.8874 12.555 20.4903 12.555C19.415 12.555 19.3452 13.0225 19.3452 13.7705V15.1021H22.033L21.7987 17.8603H19.3452V26.25H15.9797V17.8603H14.25V15.1021H15.9797V13.3959C15.9797 11.059 17.0781 9.75 19.8358 9.75C20.7939 9.75 21.4951 9.89025 22.4065 10.0773L21.9863 12.7184Z'
      fill={invert ? '#171717' : 'white'}
    />
  </svg>

export default FacebookIcon
